import Instance from "../../../../Axios";

// New Actions for the app

const GetCredFuncionariosResources = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/resources`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_FUNCIONARIOS_RESOURCES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredFuncionariosResources;